import { ClusterItemsSortBy, ClusterItemsSortTypeProvider } from '../../../types';

const sortByRelevanceProvider: ClusterItemsSortTypeProvider = () => ClusterItemsSortBy.RELEVANCE;

const sortByDateProvider: ClusterItemsSortTypeProvider = (metadata) =>
    Boolean(metadata?.dataset.created_date_field_name) ? ClusterItemsSortBy.DATE : null;

export const getSortByProviders = (): ClusterItemsSortTypeProvider[] => [sortByRelevanceProvider, sortByDateProvider];
